// Styled components
import styled from "@emotion/styled";

export const ProjectsContainer = styled.div`
  margin: 2rem auto;
  max-width: 1000px;
  padding: 1rem;
  font-family: Arial, sans-serif;
`;

export const ProjectCard = styled.div`
  background-color: #f9f9f9;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-align: left;
  margin-bottom: 1.5rem;
  padding: 1.5rem;
  position: relative; /* Ensure button is positioned relative to the card */
`;

export const ProjectTitle = styled.h3`
  margin: 0;
  font-size: 1.5rem;
  color: #333;
`;

export const ProjectDescription = styled.div`
  margin-top: 1rem;
  font-size: 1rem;
  color: #555;
  line-height: 1.5;
`;

export const ProjectButton = styled.a`
  display: inline-block;
  margin-top: 1rem; /* Adds more space above the button */
  text-align: right; /* Aligns the button to the right */
  background-color: #007bff;
  color: white;
  text-decoration: none;
  font-size: 0.9rem;
  padding: 0.5rem 1rem;
  border-radius: 5px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s;

  &:hover {
    background-color: #0056b3;
  }
`;
